module.exports = __webpack_public_path__ + "img/textimg.d16008f6.png";